import { Typography } from "antd";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useStores } from "stores";

export const CheckLimit = observer(() => {
  const { checkLimit } = useStores();

  useEffect(() => {
    checkLimit.fetchLimit();
  }, [checkLimit]);

  return checkLimit.dailyLimit !== null ? (
    <Typography.Text type="secondary">Доступно проверок на сегодня: {checkLimit.dailyLimit}</Typography.Text>
  ) : null;
});
